<template>
  <!-- :spinning="ticketsListLoading" -->
  <!-- <a-spin > -->
  <div class="container" id="workspace-tickets-list">
    <TicketItemSkeleton v-if="ticketsListLoading"/>
    
    <CustomScrollbar
      v-else-if="tickets.length > 0"
      ref="customScrollbar"
      :height="showBanner ? 'calc(100vh - 227px)' : 'calc(100vh - 192px)'"
    >
      <div v-for="ticket in tickets" :key="ticket.id">
        <WorkspaceTicketsItem :ticket="ticket" />
      </div>

       <a-spin v-if="loadingTickets" :spinning="loadingTickets" class="loading">
      </a-spin>

      <div style="height: 2px" ref="pageFlag" />
    </CustomScrollbar>
    

    <div v-else class="information__queues">
      <img src="@/app/workspace/assets/workspace1.png" alt="workspace" />
      <p>1. No se encontraron tickets</p>
    </div>

    <!-- <div class="no-data--message" v-else>
      <p>No se encontraron resultados.</p>
      <p>Por favor, prueba modificar tus filtros.</p>
    </div> -->
  </div>
  <!-- </a-spin> -->
</template>

<script>
import { computed, inject, ref } from "vue";
import { useStore } from "vuex";
import { useDebounceFn, useIntersectionObserver } from "@vueuse/core";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import WorkspaceTicketsItem from "@/app/workspace/components/cards/WorkspaceTicketItem.vue";
import { WorkspaceEvent } from "@/app/workspace/domain/events";
import EventBus from "@/app/shared/utils/eventBus";
import { ModeFetchWorkspace } from "@/app/workspace/utils/enums";

import TicketItemSkeleton from "@/app/shared/components/skeletons/TicketItemSkeleton.vue";

export default {
  components: {
    WorkspaceTicketsItem,
    CustomScrollbar,
    TicketItemSkeleton,
  },
  setup() {
    const store = useStore();

    const showBanner = inject("showBanner");
    const ticketsListLoading = inject("ticketsListLoading");

    const pageFlag = ref();

    const currentPage = computed(() => store.getters["getTicketsListPage"]);
    const hasNextPage = computed(() => store.getters["getHasNextTicketPage"]);
    const nextCursor = computed(() => store.getters["getNextCursor"]);
    const chunks = computed(() => store.getters["getWorkspaceChunks"]);

    const loadingTickets = ref(false);

    // useIntersectionObserver(pageFlag, async ([{ isIntersecting }]) => {
    //   // console.log({ page: currentPage.value, isIntersecting, hasNext: hasNextPage.value });
    //   console.log('nextCursor.value: ', nextCursor.value);
    //   // if (!isIntersecting || !hasNextPage.value) return;
    //   if (!isIntersecting || !nextCursor.value) return;

    //   if (loadingTickets.value) return;

    //   console.log('Cargando más tickets...', JSON.stringify(chunks.value.map(el => el.cursor)), nextCursor.value);
    //   // 🚫 evita duplicar: si el cursor ya existe en los chunks, no vuelvas a pedirlo
    //   const cursorLoaded = chunks.value?.some(
    //     (c) => c.cursor === nextCursor.value
    //   );

    //   console.log('cursorLoaded: ', cursorLoaded);
    //   if (cursorLoaded) {
    //     return;
    //   }
      
    //   loadingTickets.value = true;

    //   try {

    //     // const newPage = currentPage.value + 1;
    //     // await store.dispatch("fetchActiveWorkspaceTickets", { page: newPage });
    //     await store.dispatch("fetchActiveWorkspaceTickets", { 
    //       cursor: nextCursor.value,
    //       mode: ModeFetchWorkspace.Pagination,
    //     });
    //   } catch (error ) {
    //     console.log("Error: ", error);
    //   } finally {
    //     loadingTickets.value = false;
    //   }
    // });

    const loadMoreTickets = async () => {
      if (!nextCursor.value) return;
      if (loadingTickets.value) return;

      const cursorLoaded = chunks.value?.some(
        (c) => c.cursor === nextCursor.value
      );

      if (cursorLoaded) return;

      loadingTickets.value = true;

      try {
        await store.dispatch("fetchActiveWorkspaceTickets", {
          cursor: nextCursor.value,
          mode: ModeFetchWorkspace.Pagination,
        });
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        loadingTickets.value = false;
      }
    };

    const debouncedLoadMoreTickets = useDebounceFn(() => {
      loadMoreTickets();
    }, 150);

    useIntersectionObserver(pageFlag, ([{ isIntersecting }]) => {
      console.log('nextCursor.value: ', nextCursor.value);

      if (!isIntersecting) return;

      debouncedLoadMoreTickets();
    });

    return { showBanner, ticketsListLoading, pageFlag, loadingTickets };
  },
  computed: {
    tickets() {
      return this.$store.getters["getWorkspaceTickets"];
    },
    hasFilter() {
      const filters = this.$store.getters["getTicketsFilters"];

      for (const key in filters) {
        if (filters[key]) return true;
      }

      return false;
    },
    // allTickets() {
    //   return this.$store.getters["getWorkspaceTickets"];
    // },
  },
  mounted() {
    EventBus.on(WorkspaceEvent.RESET_LIST, () => 
    {
      if (this.$refs.customScrollbar)
        this.$refs.customScrollbar?.scrollToTop();
    });

    EventBus.on(WorkspaceEvent.REFRESH_TICKETS_LIST_INITIAL, async () => 
    {
      this.ticketsListLoading = true;
      await this.$store.dispatch("fetchActiveWorkspaceTickets");
      if (this.$refs.customScrollbar)
        this.$refs.customScrollbar?.scrollToTop();
      this.ticketsListLoading = false;
    });
  },
};
</script>

<style lang="sass" scoped>
.container
  border-top: 1px solid #D9D9D9

.information__queues
  text-align: center
  margin-top: 160px

.loading
  width: 100%
  display: flex
  justify-content: center
  margin-top: 5px

.no-data--message
  text-align: center
  color: $gray-6
  margin-top: 35px

  p
    margin: 0
</style>
